import React, {Component,PropTypes} from 'react';
import ReactDOM from 'react-dom';

class Overlay extends Component {

    static propTypes = {
        container: PropTypes.node.isRequired
    };

    static defaultProps = {
        container: {
            // Provide `findDOMNode` fn mocking a React component API. The `document.body`
            // reference needs to be contained within this function so that it is not accessed
            // in environments where it would not be defined, e.g. nodejs. Equally this is needed
            // before the body is defined where `document.body === null`, this ensures
            // `document.body` is only accessed after componentDidMount.
            findDOMNode: function findDOMNode() {
                return document.body;
            }
        }
    };

    componentDidMount() {
        this._renderOverlay();
    }

    componentDidUpdate() {
        this._renderOverlay();
    }

    componentWillUnmount() {
        this._unrenderOverlay();
        if (this._overlayTarget) {
            this.getContainerDOMNode()
                .removeChild(this._overlayTarget);
            this._overlayTarget = null;
        }
    }

    _mountOverlayTarget() {
        this._overlayTarget = document.createElement('div');
        this.getContainerDOMNode()
            .appendChild(this._overlayTarget);
    }

    _renderOverlay() {
        if (!this._overlayTarget) {
            this._mountOverlayTarget();
        }

        // Save reference to help testing
        this._overlayInstance = ReactDOM.render(this.renderOverlay(), this._overlayTarget);
    }

    _unrenderOverlay() {
        ReactDOM.unmountComponentAtNode(this._overlayTarget);
        this._overlayInstance = null;
    }

    getOverlayDOMNode() {
        if (!this.isMounted()) {
            throw new Error('getOverlayDOMNode(): A component must be mounted to have a DOM node.');
        }

        return this._overlayInstance.findDOMNode();
    }

    getContainerDOMNode() {
        return this.props.container.findDOMNode ?
            this.props.container.findDOMNode() : this.props.container;
    }
}

export default Overlay;